// components/dialogs/OptionDialog.jsx

import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Stack,
  Box,
  TextField,
} from "@mui/material";

import Api from "../../Api/Api";
import { toast } from "sonner";

export default function OptionDialog({
  creditDialog,
  setCreditDialog,
  newCredit,
  setNewCredit,
  fetchCredits,
}) {
  return (
    <Dialog
      open={creditDialog}
      onClose={() => setCreditDialog(false)}
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle>Add Credit</DialogTitle>

      <DialogContent>
        <TextField
          fullWidth
          label="Credit Name"
          value={newCredit}
          onChange={(e) => setNewCredit(e.target.value)}
          sx={{ mt: 2 }}
        />
      </DialogContent>

      <DialogActions>
        <Button onClick={() => setCreditDialog(false)}>Cancel</Button>

        <Button
          variant="contained"
          onClick={async () => {
            try {
              await Api.post("/dashboard/add-credit", {
                credit_name: newCredit,
              });

              setNewCredit("");
              setCreditDialog(false);

              await fetchCredits();

              toast.success("Credit Added");
            } catch (err) {
              console.error(err);
              toast.error("Failed to add credit");
            }
          }}
        >
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
}
